import {setElementAttribute, setElementAttributeByClassname, setElementVisible, ssg, sss} from "./common-utils.ts";
import {resizeElement} from "./responsive.ts";
import {loadAppropriateImages} from "./image-utils.ts";

const mainContent = document.querySelector('#main-content') as HTMLElement | null;
const sideBarMenuList = document.querySelector('.sidebar-menu__list') as HTMLUListElement | null;
const hambMenuButton = document.querySelector('#hambClickHandler') as HTMLButtonElement | null;
const headerMultiNav = document.querySelector('.header__multi') as HTMLElement | null;
const headerMainNav = document.querySelector('.header__main-nav') as HTMLElement | null;

export const header_hideAll = () => {
    sss("sideMenuActive", false)
    sss("searchBarActive", false)
    sss("liveBarActive", false)
    sss("backDropActive", false)
    setElementAttribute("searchClickHandler", "aria-expanded", false)
    setElementAttribute("hambClickHandler", "aria-expanded", false)
    setElementAttribute("liveBarClickHandler", "aria-expanded", false)
    setElementAttributeByClassname("closeLive", "aria-expanded", false)
    setElementAttribute("hambCloseHandler", "aria-expanded", false)
    mainContent?.removeAttribute("inert")
    headerMultiNav?.removeAttribute("inert")
    headerMainNav?.removeAttribute("inert")
}

export const header_hambClickHandler = () => {
    // @ts-ignore todo: figure out why this doesn't work with Typescript
    ssg('currentModalElement') && document.querySelectorAll(`#${ssg('currentModalElement')}`)[0].focus();
    if (ssg("sideMenuActive")) {
        header_hideAll()
        setElementAttribute("hambClickHandler", "aria-expanded", false)
        setElementAttribute("hambCloseHandler", "aria-expanded", false)
        setElementAttribute("hambClickHandler", "aria-labelledby", "open-side-menu")
        setElementAttributeByClassname("sidebar-menu__list", "inert", "")
        headerMainNav?.removeAttribute("inert")
        headerMultiNav?.removeAttribute("inert")
        mainContent?.removeAttribute("inert")
        hambMenuButton?.focus();
    } else {
        sss("sideMenuActive", true)
        sss("backDropActive", true)
        sss("searchBarActive", false)
        sss("liveBarActive", false)
        setElementAttribute("hambClickHandler", "aria-expanded", true)
        setElementAttribute("hambCloseHandler", "aria-expanded", true)
        setElementAttribute("hambClickHandler", "aria-labelledby", "close-side-menu")
        setElementAttributeByClassname("header__main-nav", "inert", "")
        setElementAttributeByClassname("header__multi", "inert", "")
        sideBarMenuList?.removeAttribute("inert")
        setElementAttribute("main-content", "inert", "")
    }
    header_update()
}

export const header_hambCloseHandler = () => {
    // @ts-ignore todo: figure out why this doesn't work with Typescript
    ssg('currentModalElement') && document.querySelectorAll(`#${ssg('currentModalElement')}`)[0].focus();
    if (ssg("sideMenuActive")) {
        header_hideAll()
        setElementAttribute("hambCloseHandler", "aria-expanded", false)
        setElementAttribute("hambClickHandler", "aria-labelledby", "open-side-menu")
        setElementAttributeByClassname("sidebar-menu__list", "inert", "")
        mainContent?.removeAttribute("inert")
        hambMenuButton?.focus();
    } else {
        sss("sideMenuActive", true)
        sss("backDropActive", true)
        sss("searchBarActive", false)
        sss("liveBarActive", false)
        setElementAttribute("hambCloseHandler", "aria-expanded", true)
        setElementAttribute("hambClickHandler", "aria-labelledby", "close-side-menu")
        sideBarMenuList?.removeAttribute("inert")
        setElementAttribute("main-content", "inert", "")
    }
    header_update()
}

export const header_handleEnterPress = (e: any, action: any) => {
    if (e.key === 'Enter' && e.target != null) {
        sss('currentModalElement', e.target.id);
        action(e);
        header_update()
    }
}

export const header_handleMenuClick = () => {
    header_hambClickHandler();
    setTimeout(() => {
        // @ts-ignore todo: figure this out
        document.querySelectorAll('.side-menu a')[0].focus();
    }, 300);
    header_update()
}

export const header_searchClickHandler = () => {
    // @ts-ignore todo: figure this out
    ssg('currentModalElement') && document.querySelectorAll(`#${ssg('currentModalElement')}`)[0].focus();
    if (ssg("searchBarActive")) {
        header_hideAll()
        setElementAttribute("searchClickHandler", "aria-expanded", false)
        setElementAttribute("searchClickHandler", "aria-labelledby", "open-header-search")
        mainContent?.removeAttribute("inert")
    } else {
        sss("searchBarActive", true)
        sss("backDropActive", true)
        sss("sideMenuActive", false)
        sss("liveBarActive", false)
        setElementAttribute("searchClickHandler", "aria-expanded", true)
        setElementAttribute("searchClickHandler", "aria-labelledby", "close-header-search")
        setElementAttributeByClassname("main-content", "inert", "")
    }
    header_update()
}

export const header_handleClickOutside = (e: Event) => {
    if (e != null && e.target != null) {
        const target = e.target;
        // @ts-ignore
        if (target.tagName != null && (target.tagName === "DIV" || target.tagName === "NAV" || target.tagName === "SPAN")) {
            header_hideAll();
            header_update()
        }

    }
}

const liveBarDiv = document.querySelector('#live-bar') as HTMLElement | null;
const firstLiveContainerItems = document.getElementsByClassName("live-container__item__title") as HTMLCollectionOf<HTMLElement>;
export const header_liveBarClickHandler = () => {
    resizeElement('.live-container__item')
    // @ts-ignore todo: figure out why typescript doesn't like this
    ssg('currentModalElement') && document.querySelectorAll(`#${ssg('currentModalElement')}`)[0].focus();
    if (ssg("liveBarActive")) {
        header_hideAll()
        setElementAttribute("liveBarClickHandler", "aria-expanded", false)
        setElementAttributeByClassname("closeLive", "aria-expanded", false)
        setElementAttribute("live-bar", "inert", "")
        mainContent?.removeAttribute("inert")
    } else {
        sss("liveBarActive", true)
        sss("backDropActive", true)
        sss("searchBarActive", false)
        sss("sideMenuActive", false)
        setElementAttribute("liveBarClickHandler", "aria-expanded", true)
        setElementAttributeByClassname("closeLive", "aria-expanded", true)
        liveBarDiv?.removeAttribute("inert")
        firstLiveContainerItems[0].focus();
        setElementAttribute("main-content", "inert", "")
    }
    loadAppropriateImages()
    header_update()
}

export const header_rotateBreakingNews = () => {
    const container = document.querySelector(".header-news-holder .break-news")
    if (container) {
        const itemToMove = container.children[0];
        if (itemToMove) {
            container.appendChild(itemToMove);
        }
    }
}

export const header_update = () => {
    if (ssg("sideMenuActive")) {
        // handle the main menu effects
        setElementAttribute("hambClickHandler", "class", `header__brand-nav__hamb-menu inverted`)
        setElementAttribute("header-a-1", "class", "header__brand-nav__logo inverted")
        setElementVisible("hamb-menu-hamb", false)
        setElementVisible("hamb-menu-x", true)
        setElementAttributeByClassname("live-counter", "tabindex", -1)
        setElementAttributeByClassname("main-nav-item", "tabindex", -1)
        // handle the sidebar effects
        setElementAttribute("sidemenu-nav", "class", `side-menu expandLeft-appear`)
        setElementAttribute("sidemenu-nav", "aria-hidden", false)
        setElementAttributeByClassname("side-menu-link", "tabindex", 0)
        setElementAttributeByClassname("closeSideMenu", "tabindex", 0)
        setElementAttribute("hambClickHandler", "aria-labelledby", "close-side-menu")
    } else {
        // handle the main menu effects
        setElementAttribute("hambClickHandler", "class", `header__brand-nav__hamb-menu`)
        setElementAttribute("header-a-1", "class", "header__brand-nav__logo")
        setElementVisible("hamb-menu-hamb", true)
        setElementVisible("hamb-menu-x", false)
        setElementAttributeByClassname("live-counter", "tabindex", 0)
        setElementAttributeByClassname("main-nav-item", "tabindex", 0)
        // handle the sidebar effects
        setElementAttribute("sidemenu-nav", "class", `side-menu expandLeft-collapse`)
        setElementAttribute("sidemenu-nav", "aria-hidden", true)
        setElementAttributeByClassname("side-menu-link", "tabindex", -1)
        setElementAttributeByClassname("closeSideMenu", "tabindex", -1)
        setElementAttribute("hambClickHandler", "aria-labelledby", "open-side-menu")
    }

    const isSearch: boolean = document.querySelector('#search-holder') !== null;
    const isYourArea: boolean = document.querySelector('#in-your-area-holder') !== null;
    const searchBarInputElement = document.querySelector('.search-bar-input') as HTMLInputElement | null;
    if (ssg("searchBarActive")) {
        setElementVisible("header_multi_search_img_q", false)
        setElementVisible("header_multi_search_img_x", true)
        setElementAttribute("search-bar", "class", "search-bar expand")
        setElementAttribute("search-bar", "aria-hidden", false)
        setElementAttributeByClassname("search-bar-input", "tabindex", 0)
        setElementAttributeByClassname("search-bar-btn", "tabindex", 0)
        setElementAttributeByClassname("header-social-link", "tabindex", 0)
        setElementAttributeByClassname("header_search", "tabindex", 0)
        if (!isSearch && !isYourArea) {setElementAttributeByClassname("search-bar-input", "autofocus", "")}
    } else {
        setElementVisible("header_multi_search_img_q", true)
        setElementVisible("header_multi_search_img_x", false)
        setElementAttribute("search-bar", "class", "search-bar collapse")
        setElementAttribute("search-bar", "aria-hidden", true)
        setElementAttributeByClassname("search-bar-input", "tabindex", -1)
        setElementAttributeByClassname("search-bar-btn", "tabindex", -1)
        setElementAttributeByClassname("header-social-link", "tabindex", -1)
        setElementAttributeByClassname("header_search", "tabindex", -1)
        if (isSearch || isYourArea) {searchBarInputElement?.removeAttribute("autofocus")}
    }

    if (ssg("backDropActive")) {
        setElementAttribute("backdrop", "class", "backdrop")
        setElementAttributeByClassname("backdrop", "tabindex", 0)
    } else {
        setElementAttribute("backdrop", "class", "backdrop backdrop-hidden")
        setElementAttributeByClassname("backdrop", "tabindex", -1)
    }

    if (ssg("liveBarActive") || ssg("sideMenuActive")) {
        setElementAttributeByClassname("live-counter", "tabindex", -1)
        setElementAttributeByClassname("main-nav-item", "tabindex", -1)
    } else {
        setElementAttributeByClassname("live-counter", "tabindex", 0)
        setElementAttributeByClassname("main-nav-item", "tabindex", 0)
    }

    if (ssg("liveBarActive")) {
        setElementAttributeByClassname("live-bar", "class", "live-bar expandDown-appear")
        setElementAttributeByClassname("live-bar", "aria-hidden", false)
        // setElementAttributeByClassname("live-container__item", "tabindex", 0)
        setElementAttributeByClassname("live-container__item__title", "tabindex", 0)
        setElementAttributeByClassname("closeLive", "tabindex", 0)
        setElementAttributeByClassname("language_picker", "tabindex", -1)
        setElementAttributeByClassname("header_search", "tabindex", -1)
        setElementAttributeByClassname("header-social-link", "tabindex", -1)
        setElementAttribute("searchClickHandler", "tabindex", -1)
    } else {
        setElementAttributeByClassname("live-bar", "class", "live-bar expandDown-collapse")
        setElementAttributeByClassname("live-bar", "aria-hidden", true)
        // setElementAttributeByClassname("live-container__item", "tabindex", -1)
        setElementAttributeByClassname("live-container__item__title", "tabindex", -1)
        setElementAttributeByClassname("closeLive", "tabindex", -1)
        setElementAttributeByClassname("language_picker", "tabindex", 0)
        setElementAttributeByClassname("header_search", "tabindex", 0)
        setElementAttributeByClassname("header-social-link", "tabindex", 0)
        setElementAttribute("searchClickHandler", "tabindex", 0)
    }
    if (ssg("liveBarActive") || ssg("searchBarActive")) {
        setElementAttribute("help", "tabindex", -1)
        setElementAttributeByClassname("break-news-link", "tabindex", -1)
    } else {
        setElementAttribute("help", "tabindex", 0)
        setElementAttributeByClassname("break-news-link", "tabindex", 0)
    }
}